import { render, staticRenderFns } from "./Diadoc.vue?vue&type=template&id=1832fde3"
import script from "./Diadoc.vue?vue&type=script&lang=js"
export * from "./Diadoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports